webpackJsonp([213720915766396],{

/***/ 103:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Firstsection = function (_React$Component) {
	  _inherits(Firstsection, _React$Component);
	
	  function Firstsection() {
	    _classCallCheck(this, Firstsection);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      renderLinks: false
	    };
	    return _this;
	  }
	
	  Firstsection.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      renderLinks: true
	    });
	  };
	
	  Firstsection.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      "section",
	      {
	        className: "section section--" + this.props.frontmatter.title.toLowerCase()
	      },
	      _react2.default.createElement("div", {
	        className: "section__content",
	        dangerouslySetInnerHTML: { __html: this.props.html }
	      }),
	      this.props.frontmatter.links.map(function (x, i) {
	        return _this2.state.renderLinks ? _react2.default.createElement(
	          "a",
	          { key: i, rel: "noopener noreferrer", target: "_blank", href: x.href },
	          x.text
	        ) : null;
	      }),
	      this.props.page === "cv" && _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/projects/" },
	        "Recent"
	      ),
	      this.props.page === "projects" && _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/" },
	        "CV"
	      )
	    );
	  };
	
	  return Firstsection;
	}(_react2.default.Component);
	
	exports.default = Firstsection;
	module.exports = exports["default"];

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {
	  web: [{
	    url: "https://zentrumfuerliterarischegegenwart.ch",
	    label: "Zentrum für Literarische Gegenwart"
	  }, {
	    url: "https://zurichaestheticslab.ch",
	    label: "Zurich Aesthetics Lab"
	  }, { url: "https://lisachrist.ch", label: "Lisa Christ" }, {
	    url: "https://www.helvetialuzern.ch/en",
	    label: "Restaurant Helvetia Luzern"
	  }, { url: "https://emmeneggerarch.ch/", label: "Emmenegger Architekten" }, { url: "https://kiff.ch", label: "Kiff" }, { url: "https://upset.ch", label: "Upset" }, { url: "https://versive.cc", label: "Versive" }],
	  physical: [{
	    url: "http://www.kunstbetrieb.ch/en/vanessa-billy-2021/",
	    label: "Chains, Vanessa Billy"
	  }, {
	    url: "http://www.kunstbetrieb.ch/en/maitha-abdalla-2023/",
	    label: "The Dancer’s Skin, Maitha Abdalla"
	  }],
	  teaching: [{
	    url: "https://github.com/logrinto/IAD2017.projektwoche.kontext",
	    label: "SfGZ IAD2017 – Kontext "
	  }]
	};

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _FirstSection = __webpack_require__(74);
	
	var _FirstSection2 = _interopRequireDefault(_FirstSection);
	
	var _fotoAv = __webpack_require__(53);
	
	var _fotoAv2 = _interopRequireDefault(_fotoAv);
	
	var _projects = __webpack_require__(201);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ENABLE_PREVIEWS = false;
	var LERP = 0.1;
	var FADE_MS = 250;
	
	var ProjectsPage = function (_React$Component) {
	  _inherits(ProjectsPage, _React$Component);
	
	  function ProjectsPage(props) {
	    _classCallCheck(this, ProjectsPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      hoveredUrl: null,
	      displayUrl: null,
	      prevUrl: null,
	      tooltipPos: { x: 0, y: 0 }
	    };
	    _this.targetPos = { x: 0, y: 0 };
	    _this.easedPos = { x: 0, y: 0 };
	    _this.rafId = null;
	    _this.fadeTimer = null;
	    _this.handleMouseMove = _this.handleMouseMove.bind(_this);
	    _this.animateTooltip = _this.animateTooltip.bind(_this);
	    return _this;
	  }
	
	  ProjectsPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.rafId) cancelAnimationFrame(this.rafId);
	    if (this.fadeTimer) clearTimeout(this.fadeTimer);
	  };
	
	  ProjectsPage.prototype.showScreenshot = function showScreenshot(url) {
	    var _this2 = this;
	
	    var displayUrl = this.state.displayUrl;
	
	    if (!this.screenshots[url] || url === displayUrl) return;
	    clearTimeout(this.fadeTimer);
	    this.setState({ displayUrl: url, prevUrl: displayUrl });
	    this.fadeTimer = setTimeout(function () {
	      return _this2.setState({ prevUrl: null });
	    }, FADE_MS);
	  };
	
	  ProjectsPage.prototype.hideScreenshot = function hideScreenshot() {
	    var _this3 = this;
	
	    var displayUrl = this.state.displayUrl;
	
	    if (!displayUrl) return;
	    clearTimeout(this.fadeTimer);
	    this.setState({ displayUrl: null, prevUrl: displayUrl });
	    this.fadeTimer = setTimeout(function () {
	      return _this3.setState({ prevUrl: null });
	    }, FADE_MS);
	  };
	
	  ProjectsPage.prototype.animateTooltip = function animateTooltip() {
	    this.easedPos = {
	      x: this.easedPos.x + (this.targetPos.x - this.easedPos.x) * LERP,
	      y: this.easedPos.y + (this.targetPos.y - this.easedPos.y) * LERP
	    };
	
	    this.setState({ tooltipPos: _extends({}, this.easedPos) });
	
	    var dx = Math.abs(this.targetPos.x - this.easedPos.x);
	    var dy = Math.abs(this.targetPos.y - this.easedPos.y);
	
	    if (dx > 0.1 || dy > 0.1) {
	      this.rafId = requestAnimationFrame(this.animateTooltip);
	    } else {
	      this.rafId = null;
	    }
	  };
	
	  ProjectsPage.prototype.handleMouseMove = function handleMouseMove(e) {
	    this.targetPos = { x: e.clientX + 20, y: e.clientY + 20 };
	    if (this.state.hoveredUrl && !this.rafId) {
	      this.rafId = requestAnimationFrame(this.animateTooltip);
	    }
	  };
	
	  ProjectsPage.prototype.render = function render() {
	    var _this4 = this;
	
	    var data = this.props.data;
	    var _state = this.state,
	        displayUrl = _state.displayUrl,
	        prevUrl = _state.prevUrl,
	        tooltipPos = _state.tooltipPos;
	
	    this.screenshots = (data.screenshots ? data.screenshots.edges : []).reduce(function (acc, _ref) {
	      var node = _ref.node;
	
	      if (node.screenshotUrl) acc[node.projectUrl] = node.screenshotUrl;
	      return acc;
	    }, {});
	
	    return _react2.default.createElement(
	      "article",
	      { onMouseMove: this.handleMouseMove },
	      _react2.default.createElement(
	        "header",
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            "Alex Jenter"
	          )
	        ),
	        _react2.default.createElement("img", { className: "portrait", src: _fotoAv2.default, alt: "portrait of alex jenter" }),
	        data.person.edges.map(function (x) {
	          return _react2.default.createElement(_FirstSection2.default, _extends({ key: x.node.id }, x.node, { page: "projects" }));
	        })
	      ),
	      _react2.default.createElement(
	        "main",
	        { className: "recent" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Recent Projects"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _projects2.default.web.map(function (_ref2) {
	            var url = _ref2.url,
	                label = _ref2.label;
	            return _react2.default.createElement(
	              "li",
	              { key: url, className: "recent-work-item" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "recent-work-link",
	                  href: url,
	                  target: "_blank",
	                  rel: "noopener noreferrer",
	                  onMouseEnter: ENABLE_PREVIEWS ? function (e) {
	                    var x = e.clientX + 20;
	                    var y = e.clientY + 20;
	                    _this4.targetPos = { x: x, y: y };
	                    _this4.easedPos = { x: x, y: y };
	                    _this4.setState({
	                      hoveredUrl: url,
	                      tooltipPos: { x: x, y: y }
	                    });
	                    _this4.showScreenshot(url);
	                  } : null,
	                  onMouseLeave: ENABLE_PREVIEWS ? function () {
	                    if (_this4.rafId) {
	                      cancelAnimationFrame(_this4.rafId);
	                      _this4.rafId = null;
	                    }
	                    _this4.setState({ hoveredUrl: null });
	                    _this4.hideScreenshot();
	                  } : null
	                },
	                label
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Objects / 3D"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _projects2.default.physical.map(function (_ref3) {
	            var url = _ref3.url,
	                label = _ref3.label;
	            return _react2.default.createElement(
	              "li",
	              { key: url, className: "recent-work-item" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "recent-work-link",
	                  href: url,
	                  target: "_blank",
	                  rel: "noopener noreferrer",
	                  onMouseEnter: ENABLE_PREVIEWS ? function (e) {
	                    var x = e.clientX + 20;
	                    var y = e.clientY + 20;
	                    _this4.targetPos = { x: x, y: y };
	                    _this4.easedPos = { x: x, y: y };
	                    _this4.setState({
	                      hoveredUrl: url,
	                      tooltipPos: { x: x, y: y }
	                    });
	                    _this4.showScreenshot(url);
	                  } : null,
	                  onMouseLeave: ENABLE_PREVIEWS ? function () {
	                    if (_this4.rafId) {
	                      cancelAnimationFrame(_this4.rafId);
	                      _this4.rafId = null;
	                    }
	                    _this4.setState({ hoveredUrl: null });
	                    _this4.hideScreenshot();
	                  } : null
	                },
	                label
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Teaching"
	        ),
	        _react2.default.createElement(
	          "ul",
	          null,
	          _projects2.default.teaching.map(function (_ref4) {
	            var url = _ref4.url,
	                label = _ref4.label;
	            return _react2.default.createElement(
	              "li",
	              { key: url, className: "recent-work-item" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "recent-work-link",
	                  href: url,
	                  target: "_blank",
	                  rel: "noopener noreferrer",
	                  onMouseEnter: ENABLE_PREVIEWS ? function (e) {
	                    var x = e.clientX + 20;
	                    var y = e.clientY + 20;
	                    _this4.targetPos = { x: x, y: y };
	                    _this4.easedPos = { x: x, y: y };
	                    _this4.setState({
	                      hoveredUrl: url,
	                      tooltipPos: { x: x, y: y }
	                    });
	                    _this4.showScreenshot(url);
	                  } : null,
	                  onMouseLeave: ENABLE_PREVIEWS ? function () {
	                    if (_this4.rafId) {
	                      cancelAnimationFrame(_this4.rafId);
	                      _this4.rafId = null;
	                    }
	                    _this4.setState({ hoveredUrl: null });
	                    _this4.hideScreenshot();
	                  } : null
	                },
	                label
	              )
	            );
	          })
	        )
	      ),
	      ENABLE_PREVIEWS && (displayUrl || prevUrl) && _react2.default.createElement(
	        "div",
	        {
	          className: "preview-tooltip",
	          style: { left: tooltipPos.x, top: tooltipPos.y }
	        },
	        prevUrl && _react2.default.createElement("img", {
	          key: prevUrl,
	          src: this.screenshots[prevUrl],
	          className: "preview-tooltip__layer preview-tooltip__layer--out",
	          alt: ""
	        }),
	        displayUrl && _react2.default.createElement("img", {
	          key: displayUrl,
	          src: this.screenshots[displayUrl],
	          className: "preview-tooltip__layer preview-tooltip__layer--in",
	          alt: ""
	        })
	      )
	    );
	  };
	
	  return ProjectsPage;
	}(_react2.default.Component);
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = ProjectsPage;
	
	// screenshots: allProjectScreenshot {
	//   edges {
	//     node {
	//       projectUrl
	//       screenshotUrl
	//     }
	//   }
	// }

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/foto-av.ea963a79.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-5b0edc8afab54fef768b.js